"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHrMainButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SHrMainButton_module_scss_1 = __importDefault(require("./SHrMainButton.module.scss"));
const SHrPopup_1 = require("../SHrPopup/SHrPopup");
const SHrMainButton = (p) => {
    const [show, setShow] = (0, react_1.useState)(false);
    if (!p.msg)
        return (0, jsx_runtime_1.jsx)(Button, Object.assign({}, p));
    const handleConfirm = () => {
        var _a;
        (_a = p.onClick) === null || _a === void 0 ? void 0 : _a.call(p);
        setShow(false);
    };
    return ((0, jsx_runtime_1.jsx)(SHrPopup_1.SHrPopup, { handleShow: setShow, show: show, triggerElement: (0, jsx_runtime_1.jsx)(Button, Object.assign({}, p, { onClick: () => { } })), children: (0, jsx_runtime_1.jsxs)("div", { className: `${SHrMainButton_module_scss_1.default.confirmC}`, children: [(0, jsx_runtime_1.jsx)("p", { className: `${SHrMainButton_module_scss_1.default.msgC}`, children: p.msg }), (0, jsx_runtime_1.jsxs)("div", { className: `${SHrMainButton_module_scss_1.default.buttonsC}`, children: [(0, jsx_runtime_1.jsx)(exports.SHrMainButton, { onClick: () => setShow(false), title: "Cancel", type: "secondary" }), (0, jsx_runtime_1.jsx)(exports.SHrMainButton, { onClick: handleConfirm, title: "Confirm", type: "primary" })] })] }) }));
};
exports.SHrMainButton = SHrMainButton;
const Button = ({ className, enable = true, onClick, style, title, type = "primary" }) => {
    return ((0, jsx_runtime_1.jsx)("button", { onClick: onClick, style: style, disabled: !enable, className: `${type !== "close" && type !== "back" && SHrMainButton_module_scss_1.default.contentC} ${SHrMainButton_module_scss_1.default[type]} ${className}`, children: title }));
};
